"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
(function () {
  var _React = React,
    useState = _React.useState;

  // =============================================================================================
  // VENTILATOR SIM: the start-screen tab. Pick a scenario and Education or Assessment. The
  // candidate uses the ventilator on the room monitor tablet (shown there from the start) or on
  // its own tablet (Screens -> Join by QR code -> Ventilator); the facilitator runs it from the controller's
  // Ventilator section. Everything else (engine, session, monitor, debrief) is shared.
  // devices: the machines this card offers, the first being the default: ['t1'] (the transport ventilator,
  // the Ventilator Sim card) or ['a350', 'c6'] (the anaesthetic machine and the
  // ICU ventilator, the Anaesthetics / ICU card). Each shows the scenarios written for it.
  // =============================================================================================
  var VentSimSetup = function VentSimSetup(_ref) {
    var onStart = _ref.onStart,
      _ref$devices = _ref.devices,
      devices = _ref$devices === void 0 ? ['t1'] : _ref$devices;
    var _window = window,
      Lucide = _window.Lucide;
    var VS = window.VentSim;
    var VP = window.VENT_PROFILES;
    var _useState = useState('education'),
      _useState2 = _slicedToArray(_useState, 2),
      mode = _useState2[0],
      setMode = _useState2[1];
    var _useState3 = useState(devices[0]),
      _useState4 = _slicedToArray(_useState3, 2),
      device = _useState4[0],
      setDevice = _useState4[1];
    // The anaesthetic emergencies (for novice anaesthetists) come first.
    var listFor = function listFor(d) {
      return VS.forDevice(d).slice().sort(function (a, b) {
        return (b.group === 'Anaesthetic emergencies') - (a.group === 'Anaesthetic emergencies');
      });
    };
    var list = listFor(device);
    var _useState5 = useState(list[0].id),
      _useState6 = _slicedToArray(_useState5, 2),
      choice = _useState6[0],
      setChoice = _useState6[1];
    // A scenario written for both machines stays chosen when the machine changes.
    var pickDevice = function pickDevice(d) {
      setDevice(d);
      var l = listFor(d);
      if (!l.some(function (s) {
        return s.id === choice;
      })) setChoice(l[0].id);
    };
    var devName = VP.MODEL_SHORT[device];
    var DEV_TEXT = {
      t1: 'Ventilator Sim: transport ventilator skills',
      c6: 'ICU ventilator skills',
      a350: 'Anaesthetic machine skills'
    };
    var groups = [];
    list.forEach(function (s) {
      var g = groups.find(function (x) {
        return x.name === s.group;
      });
      if (!g) {
        g = {
          name: s.group,
          items: []
        };
        groups.push(g);
      }
      g.items.push(s);
    });
    var sel = VS.byId(choice);
    var label = function label(id) {
      var p = VP.PROBLEMS.find(function (x) {
        return x.id === id;
      });
      return p ? p.label : id;
    };
    var optionClass = function optionClass(on) {
      return "text-left p-3 rounded border transition-colors ".concat(on ? 'bg-sky-900/40 border-sky-400 text-white' : 'bg-slate-900 border-slate-700 text-slate-300 hover:bg-slate-800');
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "space-y-4 animate-fadeIn",
      "data-testid": "vent-setup"
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-cyan-950/30 border border-cyan-700/50 rounded p-3 text-sm text-slate-300"
    }, /*#__PURE__*/React.createElement("p", {
      className: "font-bold text-cyan-300 mb-1 flex items-center gap-2"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "wind",
      className: "w-4 h-4"
    }), " ", DEV_TEXT[device]), device === 'a350' && /*#__PURE__*/React.createElement("p", {
      className: "text-xs text-slate-400 mb-1"
    }, "A recreation of an anaesthetic machine: the machine check, the breathing system with the bag and APL valve, fresh gas and a sevoflurane vaporiser, and its ventilator (Man/Spon, volume, pressure and pressure support modes). Built from the manufacturer's published instructions for use and product information, but the screen layout, colours and some wording, alarm delays and the gas model are the simulator's approximations. For training only; it is not the manufacturer's software."), device === 'c6' && /*#__PURE__*/React.createElement("p", {
      className: "text-xs text-slate-400 mb-1"
    }, "A recreation of an intensive care ventilator: a widescreen touch display with the controls along the bottom, volume- and pressure-controlled modes, ASV and NIV. For training only; it is not a manufacturer software."), device !== 't1' && /*#__PURE__*/React.createElement("p", {
      className: "text-xs text-slate-400 mb-1"
    }, "The ", /*#__PURE__*/React.createElement("b", null, "Anaesthetic emergencies"), " follow the Association of Anaesthetists' Quick Reference Handbook (QRH, June 2023 edition): the guideline number is in each name. The scenario text, patients and effect sizes are the simulator's and should be checked by the facilitator."), /*#__PURE__*/React.createElement("p", {
      className: "text-xs text-slate-400"
    }, "The candidate uses the ", devName, " on the room monitor tablet (it opens there; they can flip to the obs and back) or on its own tablet (", /*#__PURE__*/React.createElement("b", null, "Screens"), " \u2192 ", /*#__PURE__*/React.createElement("b", null, "Join by QR code"), " \u2192 Ventilator). You run it from the controller's ", /*#__PURE__*/React.createElement("b", null, "Ventilator"), " section: problems, lungs, and full remote control of the device. The ventilator drives SpO2, CO2 and the breathing rate.")), devices.length > 1 && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "text-[10px] text-slate-400 uppercase font-bold mb-1"
    }, "Machine"), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-1 sm:grid-cols-2 gap-2"
    }, devices.map(function (d) {
      return /*#__PURE__*/React.createElement("button", {
        key: d,
        type: "button",
        "data-vent-device": d,
        onClick: function onClick() {
          return pickDevice(d);
        },
        className: optionClass(device === d),
        "aria-pressed": device === d
      }, /*#__PURE__*/React.createElement("div", {
        className: "font-bold"
      }, VP.MODELS[d]));
    }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "text-[10px] text-slate-400 uppercase font-bold mb-1"
    }, "Mode"), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-1 sm:grid-cols-2 gap-2"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: function onClick() {
        return setMode('education');
      },
      className: optionClass(mode === 'education'),
      "aria-pressed": mode === 'education'
    }, /*#__PURE__*/React.createElement("div", {
      className: "font-bold"
    }, "Education"), /*#__PURE__*/React.createElement("div", {
      className: "text-xs text-slate-400"
    }, "The ventilator shows its alarm troubleshooting help.")), /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: function onClick() {
        return setMode('assessment');
      },
      className: optionClass(mode === 'assessment'),
      "aria-pressed": mode === 'assessment'
    }, /*#__PURE__*/React.createElement("div", {
      className: "font-bold"
    }, "Assessment"), /*#__PURE__*/React.createElement("div", {
      className: "text-xs text-slate-400"
    }, "No alarm help on the ventilator. Feedback in the debrief.")))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "text-[10px] text-slate-400 uppercase font-bold mb-1"
    }, "Scenario"), /*#__PURE__*/React.createElement("div", {
      className: "space-y-3"
    }, groups.map(function (g) {
      return /*#__PURE__*/React.createElement("div", {
        key: g.name
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-xs font-bold text-slate-400 mb-1"
      }, g.name), /*#__PURE__*/React.createElement("div", {
        className: "grid grid-cols-1 md:grid-cols-2 gap-2"
      }, g.items.map(function (s) {
        return /*#__PURE__*/React.createElement("button", {
          key: s.id,
          type: "button",
          "data-vent-scenario": s.id,
          onClick: function onClick() {
            return setChoice(s.id);
          },
          className: optionClass(choice === s.id),
          "aria-pressed": choice === s.id
        }, /*#__PURE__*/React.createElement("div", {
          className: "font-bold text-sm"
        }, s.name), /*#__PURE__*/React.createElement("div", {
          className: "text-[11px] text-slate-400 line-clamp-2"
        }, s.description));
      })));
    }))), sel && /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-900 border border-slate-700 rounded p-3 text-xs text-slate-300 space-y-1"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", {
      className: "text-white"
    }, "Patient:"), " ", sel.age, "-year-old ", sel.sex.toLowerCase(), ", ", VP.profiles[sel.profile].name.toLowerCase(), " lungs, ", sel.airway === 'tube' ? 'intubated' : 'not intubated (mask)', sel.breathing === false ? ', sedated and paralysed' : '', "."), sel.problems.length > 0 && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", {
      className: "text-white"
    }, "Problems to inject:"), " ", sel.problems.map(label).join(', '), ".")), /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: function onClick() {
        return onStart({
          scenario: choice,
          mode: mode,
          device: device
        });
      },
      className: "w-full py-4 text-lg font-bold rounded bg-sky-600 hover:bg-sky-500 text-white shadow-lg shadow-sky-900/20"
    }, device === 'a350' ? 'Start anaesthetic machine scenario' : device === 'c6' ? 'Start ICU ventilator scenario' : 'Start Ventilator Sim'));
  };
  window.VentSimSetup = VentSimSetup;
})();